import { useState } from "react";
import { ModalMenuItem, ModalSubmenu} from "../../../components";
interface ServiceTopbarProps {
  onChangeTab: (tab: string) => void;
}

export const ProviderTopbar = ( { onChangeTab } : Readonly<ServiceTopbarProps>) => {

  const [activeTab, setActiveTab] = useState<string>('Details');

  const handleTabChange = (tab: string) => {
    setActiveTab(tab);
    onChangeTab(tab);
  };

  const items: ModalMenuItem[] = [
    {
      label: 'Details',
      url: '',
      clickHandler: () => handleTabChange('Details'),
      ifActive: activeTab === 'Details' ? 'active' : '',
    },
    {
      label: 'Services',
      url: '',
      clickHandler: () => handleTabChange('Services'),
      ifActive: activeTab === 'Services' ? 'active' : '',
    },
    {
      label: 'Schedules',
      url: '',
      clickHandler: () => handleTabChange('Schedules'),
      ifActive: activeTab === 'Schedules' ? 'active' : '',
    },
  ]

  return <ModalSubmenu className="p-0" items={items} />;
};

export default ProviderTopbar;
